export const DOCUMENT_TYPE_TO_CATEGORY = {
  academic_certificate: 'Educational Certificate',
  education_ol: 'Educational Certificate',
  education_al: 'Educational Certificate',
  education_diploma: 'Educational Certificate',
  education_other: 'Educational Certificate',
  id_proof: 'Identity Proof',
  national_id: 'Identity Proof',
  experience_letter: 'Work Experience',
  recommendation_letter: 'Application Document',
  portfolio: 'Application Document',
  medical_certificate: 'Medical Certificate',
  photo: 'Photo',
  other: 'Other'
};

export const CATEGORY_TO_DOCUMENT_TYPE = {
  'Identity Proof': 'id_proof',
  ID: 'id_proof',
  'Educational Certificate': 'academic_certificate',
  Transcript: 'academic_certificate',
  'Work Experience': 'experience_letter',
  Resume: 'experience_letter',
  'Resume / CV': 'experience_letter',
  'Application Document': 'other',
  'Medical Certificate': 'medical_certificate',
  Photo: 'photo',
  Other: 'other'
};

const EDUCATION_DOCUMENT_TYPES = new Set([
  'academic_certificate',
  'education_ol',
  'education_al',
  'education_diploma',
  'education_other'
]);

export const normalizeDocumentTitle = (value) => String(value || '').trim().toLowerCase();

export const mapDocumentTypeToCategory = (documentType) => (
  DOCUMENT_TYPE_TO_CATEGORY[String(documentType || '').trim()] || 'Application Document'
);

export const mapCategoryToDocumentType = (category) => {
  const mapped = CATEGORY_TO_DOCUMENT_TYPE[String(category || '').trim()];
  if (mapped) return mapped;
  return String(category || '').toLowerCase().replace(/\s+/g, '_');
};

export const areDocumentTypesEquivalent = (leftType, rightType) => {
  const left = String(leftType || '').trim();
  const right = String(rightType || '').trim();
  if (!left || !right) return false;
  if (left === right) return true;
  return EDUCATION_DOCUMENT_TYPES.has(left) && EDUCATION_DOCUMENT_TYPES.has(right);
};

export const documentsMatchPrerequisiteSlot = (doc, prerequisite) => {
  const slotTitle = normalizeDocumentTitle(prerequisite?.title || prerequisite?.label);
  const docTitle = normalizeDocumentTitle(doc?.title || doc?.originalName);
  return Boolean(slotTitle && docTitle && slotTitle === docTitle);
};

export const resolveRequiredDocumentsFromPrerequisites = (subProduct, requirementsCategoryId = null) => {
  const prerequisites = subProduct?.requirements?.prerequisites || [];
  if (!prerequisites.length) return [];

  const hasCategoryIds = prerequisites.some((p) => p?.categoryId);
  const filtered = prerequisites
    .filter((prereq) => prereq?.isRequired || prereq?.isMandatory)
    .filter((prereq) => {
      if (hasCategoryIds) {
        if (!requirementsCategoryId) return !prereq?.categoryId;
        return !prereq?.categoryId || String(prereq?.categoryId) === String(requirementsCategoryId);
      }
      return true;
    });

  const uniqueByTitle = new Map();
  filtered.forEach((prereq) => {
    const title = String(prereq?.title || '').trim();
    if (!title || uniqueByTitle.has(title)) return;
    uniqueByTitle.set(title, {
      category: prereq.documentType,
      label: title,
      title,
      description: prereq.description,
      accept: (prereq.acceptedFormats || []).map((format) => {
        if (format === 'pdf') return '.pdf';
        if (format === 'jpg' || format === 'jpeg') return '.jpg,.jpeg';
        if (format === 'png') return '.png';
        if (format === 'doc' || format === 'docx') return '.doc,.docx';
        return `.${format}`;
      }).join(',') || 'image/*,.pdf',
      maxSize: prereq.maxFileSize || 10485760,
      instructions: prereq.instructions
    });
  });

  return Array.from(uniqueByTitle.values());
};
